import { Form, Formik } from 'formik'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap'
import CustomTabMenu from '../../../../component/CustomTabMenu'
import ThongTinRaVien from './ThongTinRaVien'
import { useState } from 'react'
import { formatDateDTO } from 'src/app/modules/utils/FormatUtils'

type Props = {
    open: boolean
    handleCloseModal: () => void
    handleSubmit: (values: any) => void
    xuTriData?: any
}

const ModalRaVien = ({
    open,
    handleCloseModal,
    handleSubmit,
    xuTriData
}: Props) => {
    const [validationSchema, setValidationSchema] = useState<any>(null);

    const listTab = [
        {
            title: 'Thông tin ra viện',
            component: <ThongTinRaVien setValidationSchema={setValidationSchema} />
        },
        {
            title: 'Thông tin điều trị',
            component: <div className="spaces h-calc-vh-250"></div>
        },
    ];

    const handleFormSubmit = (values: any) => {
        let submitData = {
            ...values,
        };
        handleSubmit(submitData);
    };

    return (
        <Modal
            centered
            className='modal fade'
            role='dialog'
            show={open}
            dialogClassName='modal-xl'
            aria-hidden='true'
        >
            <Formik<any>
                initialValues={{
                    xuTriRaVien: {
                        raVienNgay: formatDateDTO(new Date()),
                    },
                    provisionalDiagnosis: xuTriData?.icdXPrimary,
                    provisionalDiagnosisName: xuTriData?.icdXPrimaryName,
                    comorbidity: xuTriData?.comorbidity,
                }}
                validationSchema={validationSchema}
                onSubmit={handleFormSubmit}
            >
                <Form id="form-thuoc" >
                    <ModalHeader className='py-4'>
                        <h4>Cập nhật thông tin ra viện</h4>
                    </ModalHeader>
                    <ModalBody className='spaces pt-0'>
                        <CustomTabMenu danhsachTabs={listTab} childrenTab={true} />
                    </ModalBody>
                    <ModalFooter className='d-flex justify-content-end py-2 gap-2'>
                        <Button
                            className='btn-danger spaces min-w-70'
                            onClick={handleCloseModal}
                        >
                            Hủy
                        </Button>
                        <Button className='btn-fill spaces min-w-70' type='submit'>Lưu</Button>
                    </ModalFooter>
                </Form>
            </Formik>
        </Modal>
    )
}

export default ModalRaVien